<template>
  <div class="banner-status" :style="scssVars">
    <Banner color="white" outlined :loading="loading">
      <div class="banner-status-header">
        <h5 v-if="title" :class="{'banner-status-title': !loading}">
          {{ title }}
        </h5>
      </div>
      <div class="banner-status-content">
        <p v-if="description !== undefined" class="banner-status-amount">
          {{ description }}
        </p>
        <p v-if="percentage" class="banner-status-percentage">
          ({{ percentage }}%)
        </p>
      </div>
    </Banner>
  </div>
</template>

<script>
import Banner from '@/components/base/banner'

export default {
  name: 'BannerStatus',
  components: { Banner },
  props: {
    title: { type: String, required: false, default: ' ' },
    description: { type: String, required: false, default: '' },
    percentage: { type: Number, required: false, default: undefined },
    loading: { type: Boolean, required: false, default: false },
    variant: { type: String, required: false, default: 'normal' },
    badgeColor: { type: String, required: false, default: '' }
  },
  computed: {
    scssVars() {
      return { '--badge-color': this.badgeColor || '#277df6' }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.banner-status {
  .banner {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 15px 16px;
  }

  &-header {
    .banner-status-title {
      @include LabelXSmall;
      font-family: $monserratFontFamily;
      font-weight: 600;
      color: $neutral400;

      &::before {
        content: ' ';
        height: 8px;
        width: 8px;
        margin-right: 8px;
        background: var(--badge-color);
        border-radius: 50%;
        display: inline-block;
      }
    }
  }

  &-content {
    display: flex;
    align-items: center;
    column-gap: 8px;
    color: $neutral500;

    .banner-status-amount {
      @include LabelSmall;
      font-family: $monserratFontFamily;
      font-weight: 700;
    }

    .banner-status-percentage {
      @include LabelXSmall;
      font-family: $monserratFontFamily;
      font-weight: 600;
      color: $neutral400;
    }
  }
}
</style>
